const boxTokens = ({ colors }) => ({
  colors: {
    branded: colors.neutrals[6],
  },
});

export default boxTokens;
